import * as types from 'constants/ActionTypes';
import { trim } from 'lodash';

const initState = {
  bluePrintFileId: '',
  bluePrintFileName: '',
  bluePrintId: '',
  campaignDescription: null,
  canEditReportOptions: false,
  changesIn4Years: false,
  claimInfo: '',
  claimNumber: '',
  comments: '',
  dateOfLoss: '',
  deductible: '',
  estimatedTotal: '',
  externalReferenceId: '',
  includeCustomCover: false,
  includeDxfFormat: false,
  includePropertyOwnerReport: false,
  includeRxfFormat: false,
  includeXmlFormat: false,
  insuredName: '',
  marketCampaignId: '',
  notes: '',
  onBehalfOfCustomerID: '',
  orderID: 0,
  PONumber: '',
  catIdr: '',
  partnerApplicationSourceID: '',
  policyNumber: '',
  pricingTierID: '',
  promoCode: '',
  renewalDate: '',
  reportAttributes: [],
  typeOfLoss: '',
  upgradeFromMso: '',
  upgradeFromProduct: '',
  upgradeFromReportId: 0,
  upgradeFromReportUserId: 0,
  productSets: [],
  cardData: null,
  ccConsent: false,
  emailCC: [],
  commentsError: false,
  appointmentDate: '',
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case types.UPDATE_SPECIAL_INSTRUCTIONS: return { ...state, comments: action.value };
    case types.UPDATE_CHANGES_IN_4_YEARS: return { ...state, changesIn4Years: !state.changesIn4Years };
    case types.UPDATE_PROMO_CODE: return { ...state, promoCode: action.promoCode };
    case types.UPDATE_PRODUCT_SETS: return { ...state, productSets: action.productSets };
    case types.UPDATE_PLACE_ORDER_REQUEST: return { ...state, ...action.repuestFields };
    case types.PLACE_ORDER_SUCCESS: return initState;
    case types.CYBERSOURCE_TOKEN_SUCCESS: return { ...state, cardData: action.cardData };
    case types.UPDATE_CARD_CONSENT: return { ...state, ccConsent: action.ccConsent };
    case types.RESET_FINALIZE_ORDER_PAGE: return {
      ...initState,
      bluePrintFileId: state.bluePrintFileId,
      bluePrintFileName: state.bluePrintFileName,
      bluePrintId: state.bluePrintId,
    };
    case types.LOADED_FINALIZE_ORDER: return {
      ...state,
      emailCC: action.orderPreferences.emailCC?.value?.split(';').map(trim).filter(Boolean) || [],
    };
    case types.UPDATE_EMAILCC: return { ...state, emailCC: action.emailCC };
    case types.UPGRADE_REPORT_DETAILS_SUCCESS: {
      const productSets = [{
        // #genai: Upgrade API now returns objects in upgradeProductList.
        primaryProductId: action.upgradeDetails.upgradeProductList?.[0]?.productId,
        deliveryProductId: 8,
        addOnProductIds: [],
      }];
      return { ...state, productSets };
    }
    case types.ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_SUCCESS: return {
      ...state,
      ...(action.fileId ? { bluePrintFileId: action.fileId } : {}),
      ...(action.fileName ? { bluePrintFileName: action.fileName } : {}),
    };
    case types.ORDER_PAGE_UPDATE_BLUEPRINT_ID: return { ...state, bluePrintId: action.bluePrintId };
    case types.CANCEL_ORDER_SELECTION: return {
      ...state,
      bluePrintFileId: '',
      bluePrintFileName: '',
      bluePrintId: '',
    };
    default: return state;
  }
};
